__turbopack_context__.v({
  "col1": "_1eu2IG_col1",
  "header": "_1eu2IG_header",
  "img__jXaSp": "_1eu2IG_img__jXaSp",
  "img__mbYrr": "_1eu2IG_img__mbYrr",
  "img__pnfVq": "_1eu2IG_img__pnfVq",
  "img__y5Rq": "_1eu2IG_img__y5Rq",
  "items": "_1eu2IG_items",
  "row": "_1eu2IG_row",
  "row2": "_1eu2IG_row2",
  "sectionHeader": "_1eu2IG_sectionHeader",
  "textWithIcon__n1CV": "_1eu2IG_textWithIcon__n1CV",
  "textWithIcon__tmqtr": "_1eu2IG_textWithIcon__tmqtr",
  "textWithIcon__xkI0R": "_1eu2IG_textWithIcon__xkI0R",
  "textWithIcon__xl7H0": "_1eu2IG_textWithIcon__xl7H0",
  "whySection": "_1eu2IG_whySection",
  "wrapper": "_1eu2IG_wrapper",
});
